module.exports = __webpack_public_path__ + "icons.25a32416abee198dd821b0b17a198a8f.eot";


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-css/themes/default/assets/fonts/icons.eot
// module id = 6
// module chunks = 0